(function () {
  'use strict';

  function initNewsletterPopup() {
    var wrapper = document.querySelector('[data-newsletter-popup]');
    var teaser = document.querySelector('[data-popup-open]');
    if (!wrapper || !teaser || wrapper.dataset.popupReady) return;

    wrapper.dataset.popupReady = 'true';

    function openPopup() {
      wrapper.classList.add('is-open');
      document.body.classList.add('newsletter-popup-open');
      teaser.setAttribute('aria-expanded', 'true');
      var firstInput = wrapper.querySelector('input[type="email"]');
      if (firstInput) firstInput.focus();
    }

    function closePopup() {
      wrapper.classList.remove('is-open');
      document.body.classList.remove('newsletter-popup-open');
      teaser.setAttribute('aria-expanded', 'false');
      teaser.focus();
    }

    teaser.addEventListener('click', openPopup);

    wrapper.querySelectorAll('[data-popup-close]').forEach(function (element) {
      element.addEventListener('click', closePopup);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && wrapper.classList.contains('is-open')) {
        closePopup();
      }
    });

    wrapper.querySelectorAll('[data-copy-code]').forEach(function (button) {
      button.addEventListener('click', function () {
        var codeWrap = button.closest('.newsletter-popup-code-wrap');
        var codeElement = codeWrap ? codeWrap.querySelector('.newsletter-popup-code') : null;
        if (!codeElement || !navigator.clipboard) return;

        navigator.clipboard.writeText(codeElement.textContent.trim()).then(function () {
          button.textContent = 'COPIED';
          window.setTimeout(function () { button.textContent = 'COPY'; }, 1600);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNewsletterPopup);
  } else {
    initNewsletterPopup();
  }
})();